import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button, Card, Form, Input, Typography, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { LoginContext } from '../../context/loginContext';
import { PANEL_ROLES } from '../../constants/roles';
import logoOriginal from '../../img/Original.png';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const Login = () => {
  const [credentials, setCredentials] = useState({ user: '', password: '' });
  const { login } = useContext(LoginContext);
  const navigate = useNavigate();

  const handleAdminSubmit = async () => {
    try {
      const response = await axios.post(
        `${API}/usuarios/login`,
        { user: credentials.user, password: credentials.password },
        { withCredentials: true }
      );

      const { usuario, token, refreshToken } = response.data;
      const rol = String(usuario?.tiu_descripcion || '').toUpperCase();
      if (!PANEL_ROLES.includes(rol)) {
        message.error('Este ingreso no está permitido para su tipo de usuario');
        return;
      }

      login({ ...usuario, token, refreshToken, id: usuario.usu_id });
      navigate('/administrador/home', { replace: true });
    } catch (error) {
      message.error(error?.response?.data?.message || 'Credenciales incorrectas');
    }
  };

  return (
    <div
      style={{
        minHeight: 'min(100dvh, 100vh)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding:
          'max(16px, env(safe-area-inset-top)) max(16px, env(safe-area-inset-right)) max(24px, env(safe-area-inset-bottom)) max(16px, env(safe-area-inset-left))',
        background: 'linear-gradient(165deg, #f8fcf9 0%, #edf5ef 45%, #e4f0e8 100%)',
        boxSizing: 'border-box',
      }}
    >
      <Card
        style={{
          width: '100%',
          maxWidth: 420,
          background: '#ffffff',
          borderColor: '#d8e8dc',
          borderRadius: 16,
        }}
        styles={{
          body: { padding: 'clamp(20px, 5vw, 32px) clamp(16px, 4vw, 28px)' },
        }}
      >
        <div style={{ marginBottom: 24, textAlign: 'center' }}>
          <img
            src={logoOriginal}
            alt=""
            style={{
              display: 'block',
              margin: '0 auto 16px',
              maxWidth: 'min(280px, 100%)',
              height: 'auto',
              objectFit: 'contain',
            }}
          />
          <Typography.Text
            style={{
              color: '#198039',
              fontSize: 11,
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              fontWeight: 600,
            }}
          >
            Administracion
          </Typography.Text>
        </div>

        <Form layout="vertical" onFinish={handleAdminSubmit} requiredMark={false}>
          <Form.Item label={<span style={{ color: '#6b7280' }}>Usuario</span>} style={{ marginBottom: 16 }}>
            <Input
              size="large"
              placeholder="Usuario"
              value={credentials.user}
              onChange={(e) => setCredentials({ ...credentials, user: e.target.value })}
              style={{ borderRadius: 10 }}
            />
          </Form.Item>
          <Form.Item label={<span style={{ color: '#6b7280' }}>Contraseña</span>} style={{ marginBottom: 20 }}>
            <Input.Password
              size="large"
              placeholder="Contraseña"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              style={{ borderRadius: 10 }}
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              type="primary"
              htmlType="submit"
              block
              size="large"
              icon={<LockOutlined />}
              style={{ height: 44, borderRadius: 10 }}
            >
              Iniciar sesion
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
